module.exports = __webpack_public_path__ + "img/211.695cf061.png";